import { IconType } from "react-icons";
import {
  FaTableColumns,
  FaGraduationCap,
  FaBasketShopping,
  FaUser,
  FaGear,
  FaUsers,
} from "react-icons/fa6";
import i18next from "../../i18config";
import { DashBoardNavigationArrayItemType } from "@components/CommonDashboard/Types";

const DashBoardNavigationArray: DashBoardNavigationArrayItemType[] = [
  {
    id: 0,
    Icon: FaTableColumns,
    key: "overview",
    name: "Overview",
    link: "/admin-dashboard/overview",
  },
  {
    id: 1,
    Icon: FaGraduationCap,
    key: "courses",
    name: "Courses",
    link: "/admin-dashboard/courses",
  },
  {
    id: 2,
    Icon: FaBasketShopping,
    key: "orders",
    name: "Courses",
    link: "/admin-dashboard/orders",
  },
  {
    id: 3,
    Icon: FaUsers,
    key: "students",
    name: "Students",
    link: "/admin-dashboard/students",
  },
  {
    id: 4,
    Icon: FaGear,
    key: "settings",
    name: "Settings",
    link: "/admin-dashboard/settings",
  },
  {
    id: 5,
    Icon: FaUser,
    key: "admin-profile",
    name: "Profile",
    link: "/admin-dashboard/profile",
  },
];

export default DashBoardNavigationArray;
